var _path, _path2, _ellipse, _circle, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLifebuoyMinusCircle = function SvgLifebuoyMinusCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3514 72.1518C83.1216 65.4644 86.5991 56.7517 86.5991 47.2365C86.5991 37.7214 83.1216 29.0469 77.3514 22.3595C76.1285 20.8692 74.7529 19.5317 73.3007 18.3089C66.6516 12.5004 57.9389 9.02295 48.3855 9.02295C38.8703 9.02295 30.1958 12.5004 23.5084 18.2706C22.0563 19.4935 20.6806 20.8692 19.4578 22.3213C13.6493 29.0087 10.1719 37.7214 10.1719 47.2365C10.1719 56.7517 13.6493 65.4644 19.4196 72.1518C20.6806 73.6039 22.0181 74.9414 23.4702 76.2025C30.1576 81.9727 38.8703 85.4501 48.3855 85.4501C57.9389 85.4501 66.6516 81.9727 73.3007 76.1642C74.7529 74.9796 76.0903 73.6039 77.3514 72.1518ZM48.5005 59.3596C55.1958 59.3596 60.6234 53.9319 60.6234 47.2366C60.6234 40.5413 55.1958 35.1137 48.5005 35.1137C41.8052 35.1137 36.3775 40.5413 36.3775 47.2366C36.3775 53.9319 41.8052 59.3596 48.5005 59.3596Z",
    fill: "url(#paint0_linear_1197_46047)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1549 71.2189L62.4486 57.5125C64.4739 54.6847 65.6967 51.2454 65.6967 47.5005C65.6967 43.7556 64.4739 40.3163 62.4486 37.4885L76.1851 23.7872C76.847 23.127 76.9036 22.0679 76.2679 21.3824C75.7174 20.7888 75.1436 20.2205 74.5521 19.6746C73.8593 19.0351 72.7891 19.0849 72.1224 19.7516L58.3979 33.4761C55.5701 31.489 52.1691 30.3044 48.5006 30.3044C44.7556 30.3044 41.3164 31.5272 38.4886 33.5525L24.6877 19.7164C24.0212 19.0482 22.9503 18.9982 22.2598 19.6416C21.6754 20.1861 21.1083 20.7533 20.5638 21.3377C19.921 22.0276 19.9703 23.0973 20.6371 23.764L34.4762 37.6032C32.4891 40.431 31.3045 43.832 31.3045 47.5005C31.3045 51.169 32.4891 54.57 34.4762 57.3978L20.62 71.2188C19.9443 71.8928 19.9023 72.9781 20.5573 73.6723C21.0945 74.2416 21.6464 74.7935 22.2157 75.3306C22.9093 75.985 23.9934 75.9437 24.6676 75.2695L38.4886 61.4485C41.3164 63.4738 44.7556 64.6966 48.5006 64.6966C52.1691 64.6966 55.5701 63.512 58.3979 61.5249L72.1407 75.2677C72.7998 75.9268 73.8546 75.9836 74.5385 75.3504C75.1157 74.8159 75.675 74.2542 76.2191 73.6735C76.8711 72.9777 76.8292 71.8931 76.1549 71.2189ZM48.5005 59.6236C55.1959 59.6236 60.6235 54.196 60.6235 47.5007C60.6235 40.8054 55.1959 35.3778 48.5005 35.3778C41.8052 35.3778 36.3776 40.8054 36.3776 47.5007C36.3776 54.196 41.8052 59.6236 48.5005 59.6236Z",
    fill: "url(#paint1_linear_1197_46047)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: 93.5,
    rx: 36.5,
    ry: 2.5,
    fill: "#F3F3F3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75,
    r: 11,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 58.25C67.5462 58.25 60.25 65.5462 60.25 74.5C60.25 83.4538 67.5462 90.75 76.5 90.75C85.4538 90.75 92.75 83.4538 92.75 74.5C92.75 65.5462 85.4538 58.25 76.5 58.25ZM82.87 75.7188H69.87C69.2037 75.7188 68.6512 75.1663 68.6512 74.5C68.6512 73.8337 69.2037 73.2812 69.87 73.2812H82.87C83.5363 73.2812 84.0888 73.8337 84.0888 74.5C84.0888 75.1663 83.5525 75.7188 82.87 75.7188Z",
    fill: "#EF5350"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_46047",
    x1: 55.8794,
    y1: 89.6668,
    x2: 32.7418,
    y2: 18.6527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1197_46047",
    x1: 59.3331,
    y1: 86.639,
    x2: 41.8238,
    y2: 8.34445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68ABFF",
    stopOpacity: 0.21
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLifebuoyMinusCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "lifebuoy-minus-circle.4747004206079089773236859b010c99.svg";